import * as React from 'react';
const SvgInfo = () =>
  /* @__PURE__ */ React.createElement(
    'svg',
    { width: 16, height: 16, fill: 'none' },
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M1.926 8a6.074 6.074 0 1 0 12.148 0A6.074 6.074 0 0 0 1.926 8M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      d: 'M8.523 11.038v-3.61a.588.588 0 1 0-1.176 0v3.61a.588.588 0 0 0 1.176 0M7.935 5.854a.74.74 0 1 0 0-1.48.74.74 0 0 0 0 1.48',
    }),
  );
export default SvgInfo;
